import { useMemo } from "react";
import { buildNaicsCodeGroupMap } from "./buildNaicsCodeGroupMap";
import { LEGACY_NAICS_VERSION_YEAR } from "./naics-code.keys";
import { sortNaicsCodeGroupMap } from "./sortNaicsCodeGroupMap";
import { useFetchNaicsCodes } from "./useFetchNaicsCodes";

const EMPTY_GROUP_MAP = sortNaicsCodeGroupMap(new Map());

export const useNaicsCodeGroupMap = () => {
	const { naicsCodes } = useFetchNaicsCodes({ versionYear: LEGACY_NAICS_VERSION_YEAR }, true);

	return useMemo(() => {
		if (!naicsCodes) return EMPTY_GROUP_MAP;
		return sortNaicsCodeGroupMap(buildNaicsCodeGroupMap(naicsCodes));
	}, [naicsCodes]);
};
